module.exports = __webpack_public_path__ + "banquet/components/Footer/images/banquet_gray_2x.320bba9723e0f97512eaa1a0862ea9c3.png";


//////////////////
// WEBPACK FOOTER
// ./banquet/components/Footer/images/banquet_gray_2x.png
// module id = 1664
// module chunks = 1